"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateInputWidth = calculateInputWidth;
exports.trimAlignValue = trimAlignValue;
exports.getMaxAllowedInput = getMaxAllowedInput;
exports.getSliderValue = getSliderValue;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Calculating the number count and adjusting the text box width.
// Get the total number of digits on the input and subtract by 3,
// 3 is the default numbers can accommodate on the input box.
// 50 is the default width of the input.
// 6 - when the digits are more than 3 adding 6 px for each digit
// If the input has label default label width is 43 and add it to the
// text box width .

/**
 * @param {number} max - maximum input value slider can take
 * @param {boolean} hasLabel - if the input has a label suffix
 * @returns {number} - width of input
 */
function calculateInputWidth(max, hasLabel) {
  // For range slider the number will be an object/array
  // Extracting the greater value from the array.
  var valueCount = max.toString().length - 3;
  var defaultWidth = 50;

  if (valueCount > 0) {
    return defaultWidth + valueCount * 6;
  }

  return hasLabel ? defaultWidth - 10 : defaultWidth;
}
/**
 * Get aligned value on the slider.
 * @param {number} value - value from input/handle sliding
 * @param {object} props - props passed from Slider/Rail
 * @returns {Number} - aligned value of number input/slider input
 */


function trimAlignValue(value, props) {
  var _props = _objectSpread({}, props),
      step = _props.step,
      min = _props.min,
      max = _props.max;

  var val = value;

  if (val <= min) {
    val = min;
  }

  if (val >= max) {
    val = max;
  }

  var points = [];

  if (step) {
    // Safety check for: per design, float number in step is not supported.
    var alignedStep = step.toString().indexOf('.') > 0 ? Math.ceil(step) : step;
    var closestStep = Math.round((val - min) / alignedStep) * step + min;
    points.push(closestStep);
  }

  var diffs = points.map(function (point) {
    return Math.abs(val - point);
  });
  var closestPoint = points[diffs.indexOf(Math.min.apply(Math, diffs))];
  return step ? parseInt(closestPoint, 10) : parseInt(closestPoint || val, 10);
}
/**
 * @param {number} max - max value set by props
 * @returns {number} - allowed max input value
 * e.g if max = 100, max allowed = 999
 *        max = 500, max allowed = 9999
 */


function getMaxAllowedInput(max) {
  if (isNaN(max)) {
    return 0;
  }

  var length = max.toString().length;
  var numString = '';

  for (var i = 0; i < length; i++) {
    numString += '9';
  }

  return parseInt(numString, 10);
}
/**
 * @param {(number|object|string)} value - value input from props/input box
 * @param {object} props - props passed from Slider/Rail
 * @returns {number} - formatted number value for rail input
 */


function getSliderValue(value, props) {
  var sliderValue;

  if (_typeof(value) === 'object') {
    var startValue = trimAlignValue(formatInputValue(value[0]), props);
    var endValue = trimAlignValue(formatInputValue(value[1]), props);
    sliderValue = [startValue, endValue];
  } else {
    sliderValue = trimAlignValue(formatInputValue(value), props);
  }

  return sliderValue;
}
/**
 * @param {(number|string)} value - value input from props/input box
 * @returns {number} - formatted number value for rail input
 */


function formatInputValue(value) {
  if (value === undefined) {
    return 0;
  } // when a input value needs to pass to the rail, need to reset the
  // value to the correct data format.


  if (value.length === 0) {
    return 0;
  }

  if (typeof value === 'string' && !isNaN(value)) {
    return parseFloat(value);
  }

  if (typeof value === 'number') {
    return value;
  }

  return 0;
}